module.exports = __webpack_public_path__ + "img/isfull_screen.7fc8479e.svg";